import { Controller } from "@hotwired/stimulus"
import { loadJS } from "../src/utils"
import { emitCustomEvent } from "../src/utils"

export default class extends Controller {
  static targets = ["jsonInput", "jsonEditor", "editable"]

  getJSONEditor() {
    if (!window.JSONEditor) {
      return loadJS('jsonEditor').then(() => window.JSONEditor)
    } else {
      return Promise.resolve(window.JSONEditor)
    }
  }

  jsonEditorTargetConnected() {
    const element = this.jsonEditorTarget
    const initialJson = $(element).data('json')
    const mode = $(element).data('mode') || 'code'
    let editor = null
    const options = {
      mode,
      name: $(element).data('name'),
      onValidationError: (err) => {
        if ($(element).data('editable') === false) return
        console.debug($(element).data())

        if (err.length > 0) {
          $(this.jsonEditorTarget).parents('form').find('input:submit').prop('disabled', 'disabled')
        } else {
          $(this.jsonEditorTarget).parents('form').find('input:submit').prop('disabled', false)
        }
      },
      onChange: () => {
        this.jsonInputTarget.value = editor.getText()
        // 触发全局自定义事件 jsonChanged
        let params = null;
        try {
          params = JSON.parse(editor.getText());
        } catch (e) {
          params = null;
        }
        emitCustomEvent('jsonChanged', { parameters: params });
      }
    }
    this.getJSONEditor().then(JSONEditor => {
      editor = new JSONEditor(element, options)
      editor.set(initialJson)
      this.editor = editor
    })
  }

  getText() {
    if (this.editor) {
      return this.editor.getText()
    }
    return ''
  }

  jsonEditorTargetDisconnected() {
    this.editor && this.editor.destroy()
    this.editor = null
  }
  // 提供外部调用以更新 JSONEditor 内容
  updateJson(params) {
    if (this.editor && params) {
      try {
        this.editor.set(params);
        this.jsonInputTarget.value = this.editor.getText()
      } catch (err) {}
    }
  }
}
